import { Text } from '@leroy-merlin-br/backyard-react'

interface PriceDiscountProps {
  isOutlet: boolean
  price?: {
    integers: string
    decimals: string
  }
  unit: string
}

const PriceDiscount = ({ isOutlet, price, unit }: PriceDiscountProps) => {
  const hasPrice = Boolean(price?.integers)

  if (!hasPrice) {
    return null
  }

  return (
    <Text
      data-cy="product-from-price"
      color={isOutlet ? 'white' : 'black'}
      size="kilo"
      decoration="line-through"
      noMargin
    >
      R$ {price?.integers},{price?.decimals} /{unit}
    </Text>
  )
}

export default PriceDiscount
